const ProfessionalWork = [
  {
    id: 'pw-01',
    name: 'Autonomous Revenue Agents Platform',
    role: 'Senior Software Engineer',
    description:
      "Markopolo's next-gen AI automation platform, building AI-powered autonomous marketing systems that engage, convert, and retain customers 24/7 through Autonomous Revenue Agents driving sales via personalized email, SMS, WhatsApp, and voice campaigns.",
    technologies: [
      { name: 'React' },
      { name: 'NestJS' },
      { name: 'TypeScript' },
      { name: 'Redux Toolkit' },
      { name: 'MongoDB' },
      { name: 'PostgreSQL' },
      { name: 'AWS' },
    ],
    metrics: [
      'Built real-time campaign pipelines and data sync layers, achieving 99.9% uptime across channels',
      'Engineered MarkTag, a cookieless tracking system, boosting data accuracy by 40% with full GDPR/CCPA compliance',
      'Improved backend/frontend performance by 35% while mentoring engineers to lift team productivity by 25%',
    ],
    website: 'https://markopolo.ai/',
  },
  {
    id: 'pw-03',
    name: 'DeepDive: AI-Powered Consumer Intelligence',
    role: 'Senior Software Engineer',
    description:
      "A consumer intelligence engine for the world's leading brands, applying NLP and machine learning to understand not just what people are saying, but what they mean, feel, and where they're headed. Processes vast streams of unstructured consumer signals across social platforms, identifying behavioral patterns and distilling them into precise, actionable intelligence — going beyond what happened to explain why, and what to do next.",
    technologies: [
      { name: 'React' },
      { name: 'NestJS' },
      { name: 'TypeScript' },
      { name: 'Playwright' },
      { name: 'PostgreSQL' },
      { name: 'AWS' },
      { name: 'Redux Toolkit' },
    ],
    metrics: [
      'Engineered multilingual NLP pipeline ingesting signals across 20+ platforms and 120+ languages',
      'Built predictive detection engine surfacing behavioral signals up to 6-12 weeks early',
      'Architected intelligence layer analyzing 65B+ UGCs, driving 21% campaign budget efficiency',
    ],
    website: 'https://www.deepdiveplatform.com/',
  },
  {
    id: 'pw-02',
    name: 'Marketing Automation Platform',
    role: 'Software Engineer',
    description:
      "Built scalable, high-performing web applications powering Markopolo's marketing automation platform — an advertising tool used by thousands of global businesses, letting 50M+ microbusinesses and creators launch targeted ads in seconds with no experience required.",
    technologies: [
      { name: 'TypeScript' },
      { name: 'React.js' },
      { name: 'Redux' },
      { name: 'Node.js' },
      { name: 'Express.js' },
      { name: 'MongoDB' },
      { name: 'AWS' },
    ],
    metrics: [
      'Optimized load time by 2x, boosting user satisfaction by 10%',
      'Shipped 50+ features with 99% cross-browser compatibility and accessibility',
      'Resolved 100+ technical issues, cutting downtime by 50%, while mentoring juniors to a 30% skill gain',
    ],
    website: 'https://app.markopolo.ai/',
  },
];

export default ProfessionalWork;
